/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getAreaListing = (params) =>
  makeApiCall(`/footprint/areas-improvement/list`, `POST`, params);

export const postAreaStore = (params) =>
  makeApiCall(`/footprint/areas-improvement/store`, `POST`, params);

export const getArea = (params) => makeApiCall(`/footprint/areas-improvement/view`, `POST`, params);

export const postArchiveArea = (params) =>
  makeApiCall(`/footprint/areas-improvement/delete`, `POST`, params);

export const postRestoreArea = (params) =>
  makeApiCall(`/footprint/areas-improvement/restore`, `POST`, params);
